// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3D6gI","buttons":"PendingPaymentAlert_buttons__3weP_"};